/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Open_GiftInputs */

const en_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open My Gift`)
};

const ar_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح هديتي`)
};

const de_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne mein Geschenk`)
};

const es_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir mi regalo`)
};

const fr_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir mon Cadeau`)
};

const it_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il mio regalo`)
};

const ja_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ギフトを開く`)
};

const ko_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선물 열기`)
};

const pt_br_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir meu presente`)
};

const ru_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть мой подарок`)
};

const th_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดของขวัญของฉัน`)
};

const tr_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hediyemi Aç`)
};

const zh_cn_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开礼物`)
};

const zh_tw_btn_open_gift = /** @type {(inputs: Btn_Open_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打開禮物`)
};

/**
* | output |
* | --- |
* | "Open My Gift" |
*
* @param {Btn_Open_GiftInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_open_gift = /** @type {((inputs?: Btn_Open_GiftInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Open_GiftInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_open_gift(inputs)
	if (locale === "ar") return ar_btn_open_gift(inputs)
	if (locale === "de") return de_btn_open_gift(inputs)
	if (locale === "es") return es_btn_open_gift(inputs)
	if (locale === "fr") return fr_btn_open_gift(inputs)
	if (locale === "it") return it_btn_open_gift(inputs)
	if (locale === "ja") return ja_btn_open_gift(inputs)
	if (locale === "ko") return ko_btn_open_gift(inputs)
	if (locale === "pt_br") return pt_br_btn_open_gift(inputs)
	if (locale === "ru") return ru_btn_open_gift(inputs)
	if (locale === "th") return th_btn_open_gift(inputs)
	if (locale === "tr") return tr_btn_open_gift(inputs)
	if (locale === "zh_cn") return zh_cn_btn_open_gift(inputs)
	return zh_tw_btn_open_gift(inputs)
});